import styled from 'styled-components';

export const ModalStyle = styled.div`
  .form-group {
    label {
      margin: 10px 0;
    }
  }
`;
